import { useEffect, useState } from 'react'
import { useAuth, useUser, useClerk } from '@clerk/clerk-react'
import { loadCurrentUserSeat, provisionFromInvite } from '../services/tenancy.js'

// Being signed in is not the same as being on the team (2026-10-19). Sign-up was open, so a client
// could create an account and land on the full project list. The outline now opens only for an
// account that holds a seat — or picks one up from a pending invite on its first visit, which is
// the normal path for a new team member. Everyone else gets a plain "no access" page.
// The server enforces the same rule (api/_timeAuth.js); this is what the person sees.
export default function TeamGate({ children }) {
  const { getToken } = useAuth()
  const { user } = useUser()
  const { signOut } = useClerk()
  const [state, setState] = useState('checking') // checking | ok | denied
  const [attempt, setAttempt] = useState(0)

  useEffect(() => {
    let cancelled = false
    window.__clerkGetToken = () => getToken()
    setState('checking')
    ;(async () => {
      let seat = await loadCurrentUserSeat(user?.id || null)
      if (!seat) seat = await provisionFromInvite()
      if (!cancelled) setState(seat ? 'ok' : 'denied')
    })()
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, attempt])

  if (state === 'ok') return children
  if (state === 'checking') return null

  const email = user?.primaryEmailAddress?.emailAddress || 'this account'
  const btn = {
    fontFamily: '"DM Sans",sans-serif', fontSize: 13, padding: '8px 16px', borderRadius: 4,
    border: '0.5px solid var(--aj-border-mid, #b9c4c6)', background: 'transparent', color: 'inherit', cursor: 'pointer',
  }
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--aj-bg-page, #f4f7f8)', color: 'var(--aj-text, #07272D)', padding: 16 }}>
      <div style={{ maxWidth: 420, textAlign: 'center', fontFamily: '"DM Sans",sans-serif' }}>
        <div style={{ fontFamily: 'Montserrat,sans-serif', fontSize: 12, letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 16 }}>Alder James</div>
        <div style={{ fontSize: 15, lineHeight: 1.5, marginBottom: 8 }}>
          {email} isn't set up for the Alder James studio app.
        </div>
        <div style={{ fontSize: 13, lineHeight: 1.5, color: 'var(--aj-text-muted, #5b6b6e)', marginBottom: 20 }}>
          If you were sent a link to a project, open that link directly. If you're joining the studio, ask for an invitation.
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
          <button style={btn} onClick={() => setAttempt(a => a + 1)}>Try again</button>
          <button style={btn} onClick={() => signOut({ redirectUrl: '/' })}>Sign out</button>
        </div>
      </div>
    </div>
  )
}
